module.exports = __webpack_public_path__ + "media/images/icon/i-arrow-ambassador-6582abb18dd6e445abedec62509bde62.svg";